@if (showModal()) {
<app-modal (closeModal)="close()">
  <h1 modal-title>{{ buttonText }} Almacén</h1>

  <form
    [formGroup]="warehouseForm"
    (submit)="submit()"
    class="flex flex-col gap-4"
    modal-content
  >
    <div class="flex flex-col gap-2">
      <label for="warehouse-name">Nombre</label>
      <input
        type="text"
        id="warehouse-name"
        formControlName="name"
        class="basic-input"
      />
    </div>

    <div class="flex flex-col gap-2">
      <label for="warehouse-location">Ubicación</label>
      <input
        type="text"
        id="warehouse-location"
        formControlName="location"
        class="basic-input"
      />
    </div>

    <div
      class="flex flex-col-reverse sm:flex-row sm:justify-between sm:space-x-2"
    >
      <button type="button" class="secondary normal" (click)="cancel()">
        Cancelar
      </button>

      <button
        type="submit"
        [disabled]="warehouseForm.invalid"
        class="primary normal"
      >
        {{ buttonText }}
      </button>
    </div>

    @if (confirmationMessage && warehouseForm.pristine) {
    <span class="mt-2 text-green-700 text-sm">{{ confirmationMessage }}</span>
    } @if (errorMessage && warehouseForm.pristine) {
    <span class="mt-2 text-red-700 text-sm">{{ errorMessage }}</span>
    }
  </form>
</app-modal>
}
